var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 297 297",
    style: {
      enableBackground: "new 0 0 297 297"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 148.5,
    cy: 105.447,
    r: 17.221
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.283 122.668c0-68.971-50.149-119.913-52.284-122.047-.4-.399-.933-.621-1.499-.621s-1.099.222-1.501.622c-2.133 2.133-52.282 53.075-52.282 122.046v68.885c0 16.434 7.428 31.147 19.082 41.019 4.56-14.835 18.39-25.651 34.701-25.651 16.321 0 30.155 10.828 34.708 25.677 11.659-9.872 19.075-24.605 19.075-41.044v-68.886zM148.5 133.266c-15.34 0-27.819-12.478-27.819-27.818 0-15.34 12.479-27.819 27.819-27.819s27.819 12.479 27.819 27.819c0 15.339-12.479 27.818-27.819 27.818z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.5 223.876c-10.665 0-19.341 8.676-19.341 19.341 0 4.58 4.552 21.068 17.379 52.466.328.8 1.097 1.317 1.962 1.317s1.634-.518 1.961-1.317c12.828-31.397 17.38-47.886 17.38-52.466 0-10.665-8.676-19.341-19.341-19.341zM224.879 218.502l-8.174-8.174c-4.366 15.828-14.114 29.442-27.139 38.761v11.349c0 2.811 1.116 5.506 3.104 7.494l17.221 17.222a10.598 10.598 0 0 0 18.092-7.494v-51.663a10.605 10.605 0 0 0-3.104-7.495zM80.295 210.328l-8.174 8.174a10.6 10.6 0 0 0-3.104 7.494v51.663a10.6 10.6 0 0 0 10.596 10.598c2.758 0 5.468-1.076 7.496-3.104l17.221-17.222a10.6 10.6 0 0 0 3.104-7.494v-11.336c-13.027-9.32-22.774-22.94-27.139-38.773z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.6d2a1aa2142a2f5d9f6982698488308e.svg";
export { ForwardRef as ReactComponent };